<rt-group #dateDropdownTrigger="rtOverlayOrigin" rt-overlay-origin>
  @if (!showWeekRange()) {
    <rt-button
      [pressed]="dateDropdown.open"
      [class.no-date]="!currentDate"
      [class.full-width]="fullWidth()"
      [disabled]="disabled()"
      (click)="toggleDropdown(dateDropdown)"
      variant="outline"
      class="schedule-date"
    >
      <div layout layout-full-width layout-align-items-center class="text-content">
        @if (leftIcon?.length) {
          <rt-icon [name]="leftIcon!" />
        }
        {{
          currentDate
            ? currentDate
            : placeholder() || ('app.interview.schedule_dialog.date_placeholder' | translate)
        }}
      </div>
      @if (rightIcon?.length) {
        <rt-icon [name]="rightIcon!" colorToken="colorIconDefault" />
      }
    </rt-button>
  }
  @if (showWeekRange()) {
    <rt-button
      [disabled]="disabled()"
      (click)="toggleDropdown(dateDropdown)"
      class="range"
      variant="outline"
      ngPreserveWhitespaces
    >
      <rt-icon name="calendar-blank" />
      @if (!weekView()) {
        <span>{{ getFormattedDay() }} {{ getFormattedMonthAndYear() }}</span>
      }

      @if (weekView()) {
        <span>{{ getFormattedInterval() }} {{ getFormattedDate() }}</span>
      }
    </rt-button>
  }
</rt-group>

<ng-template
  #dateDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="dateDropdownTrigger"
  [rtConnectedOverlayPosition]="datePickerPositions"
  [open]="dateDropdown.open"
  (backdropClick)="toggleDropdown(dateDropdown)"
>
  <rt-schedule-date-dropdown
    [currentDate]="currentDate ?? ''"
    [direction]="direction()"
    [dropdownRef]="dateDropdown"
    [closeOnDateChange]="closeOnDateChange()"
    [showClear]="showClear()"
    [useYearNav]="useYearNav()"
    [blackoutDates]="blackoutDates()"
    (dateChange)="onDateChange($event, dateDropdown)"
  />
</ng-template>
